import { render } from "./Dashbord.vue?vue&type=template&id=45f9772f&scoped=true"
import script from "./Dashbord.vue?vue&type=script&lang=js"
export * from "./Dashbord.vue?vue&type=script&lang=js"

import "./Dashbord.vue?vue&type=style&index=0&id=45f9772f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f9772f"]])

export default __exports__